/** Глубина цепочки «Назад» между страницами с детальной информацией */
export const MAX_DETAIL_NAV_STACK = 10;

export function currentNavPath(location) {
  return `${location.pathname}${location.search || ''}`;
}

/**
 * Состояние для перехода на другую детальную страницу: в стек добавляется текущий URL.
 * @param {import('react-router-dom').Location} location
 * @param {Record<string, unknown>} [extraState] — fromUsers, fromOrders, fromComplaint и т.д.
 */
export function pushDetailNavState(location, extraState = {}) {
  const here = currentNavPath(location);
  const prev = Array.isArray(location.state?.navBackStack) ? location.state.navBackStack : [];
  const navBackStack = [...prev, here].slice(-MAX_DETAIL_NAV_STACK);
  return { ...extraState, navBackStack };
}

/**
 * Состояние для navigate() после шага «Назад» по navBackStack: укороченный стек + поля для списков и цепочек.
 */
export function buildBackNavigationState(currentState, targetPath, nextStack) {
  if (!currentState) return { navBackStack: nextStack };
  const base = targetPath.split('?')[0];
  const out = { navBackStack: nextStack };

  if (currentState.fromUsers != null && (base === '/users' || base.startsWith('/users/'))) {
    out.fromUsers = currentState.fromUsers;
  }
  if (currentState.fromOrders) {
    if (base === '/orders' && currentState.fromOrders.searchParams) {
      out.searchParams = currentState.fromOrders.searchParams;
    } else if (base.startsWith('/orders/')) {
      out.fromOrders = currentState.fromOrders;
    }
  }
  if (currentState.fromComplaint && base.startsWith('/complaints/')) {
    out.fromComplaint = currentState.fromComplaint;
  }
  if (currentState.fromLogs && (base === '/logs' || base.startsWith('/logs'))) {
    out.fromLogs = currentState.fromLogs;
  }
  if (currentState.fromOrder && base.startsWith('/users/')) {
    out.fromOrder = currentState.fromOrder;
  }
  if (currentState.fromUser && base.startsWith('/users/')) {
    out.fromUser = currentState.fromUser;
  }
  if (currentState.fromPromo && base.startsWith('/admin/promo-codes/')) {
    out.fromPromo = currentState.fromPromo;
  }

  return out;
}
